'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @module makeModifiers
 *
 * @description
 *
 * Add one or more modifiers to the base block name.
 *
 * Separate multiple modifiers by whitespace.
 *
 * *This maker is always applied.*
 *
 * @example
 *
 * import * as pluginModifiers from 'dumb-bem/lib/plugins/makeModifiers'
 *
 * pluginModifiers.maker('block', { modifier: 'large' }, { delimiters: { modifier: '--' } })
 *   // => 'block--large'
 *
 * pluginModifiers.maker('block', { modifier: 'large success' }, { delimiters: { modifier: '_' } })
 *   // => 'block_large block_success'
 *
 * pluginModifiers.propsToRemove
 *   // => ['modifier']
 *
 */
var maker = exports.maker = function maker(block, _ref, _ref2) {
  var _ref$modifier = _ref.modifier,
      modifier = _ref$modifier === undefined ? '' : _ref$modifier;
  var delimiters = _ref2.delimiters;
  return modifier && modifier.split(/\s+/).filter(function (x) {
    return x;
  }).map(function (item) {
    return '' + block + delimiters.modifier + item;
  });
};

var propsToRemove = exports.propsToRemove = ['modifier'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/dumb-bem/lib/plugins/makeModifiers.js
// module id = 1171
// module chunks = 0